import { createFhbfCaseId } from '../../../common/helpers/createCaseIds';
import formatter from '../../../common/helpers/formatter';
import { Client } from '../../../common/types/client';
import { DecryptedItem } from '../../../common/types/items';

const reactAppVersion = process.env.REACT_APP_VERSION;

export const moveClientToCounselingCenter = (
  currentClient: Client,
  clients: DecryptedItem<Client>[],
  location: string,
) => {
  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    const caseId = createFhbfCaseId('BS', clients);

    return {
      firstContactDate: currentClient.firstContactDate,
      date: formatter.formatIsoDate(new Date().toString()),

      generalConditions: currentClient.generalConditions,
      mission: currentClient.mission,
      dutyOfConfidentiality: currentClient.dutyOfConfidentiality,
      lackOfRightToRefuseToTestify: currentClient.lackOfRightToRefuseToTestify,
      dataPrivacy: currentClient.dataPrivacy,
      dataStorage: currentClient.dataStorage,
      recordAccompanyingPersons: currentClient.recordAccompanyingPersons,
      dogPresent: currentClient.dogPresent,

      advisor: currentClient.advisor,
      caseId,
      name: currentClient.name,
      phone: currentClient.phone,
      address: currentClient.address,
      faxInput: currentClient.faxInput,
      incident: currentClient.incident,
      domesticViolence: currentClient.domesticViolence,
      exPartnerStalking: currentClient.exPartnerStalking,
      notice: currentClient.notice,
      age: currentClient.age,
      origin: currentClient.origin,
      nationality: currentClient.nationality,
      children: currentClient.children,
      ageOfChildrenZeroToThreeYears: currentClient.ageOfChildrenZeroToThreeYears,
      ageOfChildrenFourToSixYears: currentClient.ageOfChildrenFourToSixYears,
      ageOfChildrenSevenToThirteenYears: currentClient.ageOfChildrenSevenToThirteenYears,
      ageOfChildrenFourteenToSeventeenYears: currentClient.ageOfChildrenFourteenToSeventeenYears,
      stabilizationGroup: currentClient.stabilizationGroup,
      traumaCounseling: currentClient.traumaCounseling,
    };
  }
};
